define('Store.Selector.Hours.Helper', [
    'underscore'
], function StoreSelectorHoursHelpers(
    _
) {
    'use strict';

    return {
        getMinimumTimeRepresentation: function getMinimumTimeRepresentation(momentTime) {
            if (momentTime.minutes()) {
                return momentTime.format('h:ma');
            }
            return momentTime.format('ha');
        },
        getHoursForDay: function getHoursForDay(dayOfWeek, store) {
            return _.find(store.get('hours'), function findHoursForDay(line) {
                return line.daysOfWeek && line.daysOfWeek.indexOf(dayOfWeek) !== -1;
            });
        },
        isStoreOpen: function isStoreOpen(store) {
            var moment = window.moment;
            var currentDateTime = moment.tz('America/Denver');
            var dayOfWeek = currentDateTime.day();
            var dayOfWeekOpenHours = this.getHoursForDay(dayOfWeek, store);
            var openMoment;
            var closeMoment;
            if (!dayOfWeekOpenHours) {
                return false;
            }
            openMoment = moment.tz(
                currentDateTime.format('YYYY-MM-DD') + ' ' + dayOfWeekOpenHours.openingTime,
                'YYYY-MM-DD h:m a',
                'America/Denver'
            );
            closeMoment = moment.tz(
                currentDateTime.format('YYYY-MM-DD') + ' ' + dayOfWeekOpenHours.closingTime,
                'YYYY-MM-DD h:m a',
                'America/Denver'
            );
            return currentDateTime >= openMoment && currentDateTime <= closeMoment;
        },
        getTodayHoursString: function getTodayHoursString(store) {
            var moment = window.moment;
            var currentDateTime = moment.tz('America/Denver');
            var dayOfWeek = currentDateTime.day();
            var dayOfWeekOpenHours = this.getHoursForDay(dayOfWeek, store);
            var openMoment;
            var closeMoment;
            if (!dayOfWeekOpenHours) {
                return '';
            }

            openMoment = moment.tz(
                currentDateTime.format('YYYY-MM-DD') + ' ' + dayOfWeekOpenHours.openingTime,
                'YYYY-MM-DD h:m a',
                'America/Denver'
            );
            closeMoment = moment.tz(
                currentDateTime.format('YYYY-MM-DD') + ' ' + dayOfWeekOpenHours.closingTime,
                'YYYY-MM-DD h:m a',
                'America/Denver'
            );
            return this.getMinimumTimeRepresentation(openMoment) + '-' + this.getMinimumTimeRepresentation(closeMoment);
        }
    };
});
